export default {
  notifications: {
    loadError: "Не удалось загрузить уведомления",
    bell: {
      aria: "Уведомления",
      unreadAria: "Уведомления, непрочитанных: {{count}}",
    },
    popover: {
      title: "Уведомления",
      unreadSummary_one: "{{count}} непрочитанное",
      unreadSummary_few: "{{count}} непрочитанных",
      unreadSummary_many: "{{count}} непрочитанных",
      unreadSummary_other: "{{count}} непрочитанных",
      allRead: "Все уведомления прочитаны",
      empty: "Пока нет уведомлений",
      markAllRead: "Прочитать все",
      showAll: "Показать все",
    },
    sidebar: {
      item: "Уведомления",
      itemUnreadAria: "Уведомления, непрочитанных: {{count}}",
    },
    item: {
      unreadAria: "Непрочитанное уведомление: {{title}}",
      markReadAria: "Отметить как прочитанное: {{title}}",
    },
    toast: {
      aggregated_one: "У вас {{count}} новое уведомление",
      aggregated_few: "У вас {{count}} новых уведомления",
      aggregated_many: "У вас {{count}} новых уведомлений",
      aggregated_other: "У вас {{count}} новых уведомлений",
    },
    page: {
      title: "Уведомления",
      subtitle: "История событий и напоминаний от портала.",
      tabsAria: "Разделы уведомлений",
      modeGroupAria: "Фильтр по статусу прочтения",
      tabs: {
        feed: "Лента",
        settings: "Настройки",
      },
      filters: {
        all: "Все",
        unread: "Непрочитанные",
        type: "Тип уведомления",
        typeAll: "Все типы",
        fromDate: "С какой даты",
        fromDateAria: "Выбор даты начала периода",
        reset: "Сбросить фильтры",
      },
      bulk: {
        selectAll: "Выбрать всё на странице",
        selectOne: "Выбрать «{{title}}»",
        selectedCount_one: "Выбрано: {{count}}",
        selectedCount_few: "Выбрано: {{count}}",
        selectedCount_many: "Выбрано: {{count}}",
        selectedCount_other: "Выбрано: {{count}}",
        markRead: "Прочитать",
        delete: "Удалить",
      },
      pageRange: "{{from}}–{{to}} из {{total}}",
      pageIndicator: "Страница {{current}} из {{total}}",
      prev: "Назад",
      next: "Вперёд",
      empty: "Уведомлений нет",
      emptyFiltered: "По выбранным фильтрам ничего не найдено",
      deleteItem: "Удалить уведомление",
      clearRead: "Очистить прочитанные",
      clearReadConfirm: "Удалить все прочитанные уведомления? Это действие нельзя отменить.",
      clearReadDo: "Очистить",
      clearReadDone: "Прочитанные уведомления удалены",
      clearReadFailed: "Не удалось очистить уведомления",
    },
    settings: {
      title: "Каналы уведомлений",
      subtitle: "Выберите, куда присылать каждый тип уведомлений.",
      perTypeSectionTitle: "Настройки по типам",
      perTypeSectionHint: "Переключатели сохраняются сразу после нажатия.",
      inAppDescription: "Лента и колокольчик в личном кабинете портала.",
      emailDescription: "Дублирование письмом на адрес из вашего профиля.",
      groupEvents: "Мероприятия",
      groupDeposits: "Депонирование",
      groupProjects: "Проекты",
      groupOther: "Прочее",
      typeHeader: "Тип уведомления",
      inAppHeader: "В приложении",
      emailHeader: "E-mail",
      loadError: "Не удалось загрузить настройки",
      updateFailed: "Не удалось сохранить изменения",
      empty: "Типы уведомлений недоступны",
      toggleInAppAria: "Уведомления в приложении: {{type}}",
      toggleEmailAria: "Уведомления по e-mail: {{type}}",
    },
    type: {
      "deposit.status_changed": "Статус депозита",
      "event.registration_registered": "Регистрация на мероприятие",
      "event.registration_pending": "Участие в мероприятии: заявка ожидает подтверждения",
      "event.registration_approved": "Участие в мероприятии: заявка одобрена",
      "event.registration_rejected": "Участие в мероприятии: заявка отклонена",
      "project.status_changed": "Статус проекта",
      "project.team_invitation": "Приглашение в команду проекта",
    },
  },
  toast: {
    regionAria: "Уведомления системы",
    close: "Закрыть уведомление",
  },
}
